<template>
  <ui-box label="Nové publikum">
    <div class="mb-4">
      <v-select
        v-for="(audience, index) in customAudiences"
        :key="`custom-audience-${index}`"
        :items="audiencesList"
        item-text="name"
        item-value="id"
        outlined
        hide-details
        return-object
        :value="audience"
        label="Publikum stávajících okruhů uživatelů"
        class="mb-4 c-input--append-button"
        @input="customAudienceUpdate({ audience: $event, index })"
        append-outer-icon="mdi-close"
        @click:append-outer="customAudienceRemove(index)"
      />
      <v-btn
        small
        rounded
        text
        color="navy"
        class="ml-n2"
        @click="customAudienceAppend()"
      >
        <v-icon left>
          mdi-plus-circle-outline
        </v-icon>
        Zahrnout další publikum
      </v-btn>
    </div>

    <div>
      <v-select
        v-for="(audience, index) in excludedCustomAudiences"
        :key="`custom-audience-${index}`"
        :items="audiences"
        item-text="name"
        item-value="id"
        outlined
        hide-details
        return-object
        :value="audience"
        label="Publikum stávajících okruhů uživatelů"
        class="mb-4 c-input--append-button"
        @input="excludedCustomAudienceUpdate({ audience: $event, index })"
        append-outer-icon="mdi-close"
        @click:append-outer="excludedCustomAudienceRemove(index)"
      />
      <v-btn
        small
        rounded
        text
        color="navy"
        class="ml-n2"
        @click="excludedCustomAudienceAppend"
      >
        <v-icon left>
          mdi-minus-circle-outline
        </v-icon>
        Vyloučit publikum
      </v-btn>
    </div>
  </ui-box>
</template>

<script>
import { call, get, sync } from "vuex-pathify"

export default {
  name: "SetOfAudiences",
  props: {
    storeNamespace: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...get("audiences", ["audiences"]),
    audiencesList() {
      // we need only custom and lookalike audiences
      return this.audiences.filter(i => !i.audienceType)
    },
  },
  methods: {
    ...call("audiences", ["loadAudiences"]),
  },
  mounted() {
    this.loadAudiences()
  },
  beforeCreate() {
    const storeNamespace = this.$options.propsData.storeNamespace

    if (!this.$options.computed) {
      this.$options.computed = {}
    }
    if (!this.$options.methods) {
      this.$options.computed = {}
    }

    Object.assign(this.$options.computed, {
      ...sync(`${storeNamespace}/model@audience.targeting`, [
        "customAudiences",
        "excludedCustomAudiences",
      ]),
    })

    Object.assign(this.$options.methods, {
      ...call(`${storeNamespace}`, [
        "customAudienceAppend",
        "customAudienceRemove",
        "customAudienceUpdate",
        "excludedCustomAudienceAppend",
        "excludedCustomAudienceRemove",
        "excludedCustomAudienceUpdate",
      ]),
    })
  },
}
</script>
